import billingReducer, { billingApi } from '@reducers/billing/billing';

export { billingApi } from '@reducers/billing/billing';

export const billingMiddlewares = [billingApi.middleware];
export const billingReducers = {
  billing: billingReducer,
  [billingApi.reducerPath]: billingApi.reducer,
};
